export enum STEPS {
  REVIEW_RECORD = 'review_record',
  EXPLAIN_RECORD = 'explain_record',
  STORY_TODAY = 'story_today',
  REVIEW_AND_SHARE = 'review_and_share',
}
